import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';
import { ReactComponent as LoaderIcon } from '../../../assets/icons/loaderNeutro.svg';
import { ReactComponent as LoaderIconLight } from '../../../assets/icons/loader_white.svg';

const Loader = props => (
  <div className={`loader ${props.light && 'loader--light'}`}>
    {props.light ? (
      <LoaderIconLight className="loader_icon" />
    ) : (
      <LoaderIcon className="loader_icon" />
    )}
    {props.text && <span>{props.text}</span>}
  </div>
);

Loader.propTypes = {
  light: PropTypes.bool,
  text: PropTypes.string
};

Loader.defaultProps = {
  light: undefined,
  text: undefined
};

export default Loader;
